@let filteredItems = store.filteredItemsSg();
@let totalCount = store.totalCountSg();
@let filteredCount = store.filteredCountSg();
@let selectedCount = store.selectedCountSg();
@let virtualScrollPxHeight = virtualScrollPxHeightSg();
@let values = store.valuesSg();
@let selectedValues = store.selectedValuesSg();
@let configOverlay = store.configOverlaySg();
@let searchValue = store.searchValueSg();
@let origin = originSg();
@let isOpen = store.isOpenSg();
@let isLoading = store.isLoadingSg();
@let error = store.presentableErrorSg();
@let overlayWidth = overlayWidthPxSg();

@if (isOpen) {
  <atn-ds-attached-overlay
    [origin]="origin"
    (backdropClick)="
      $event.stopPropagation(); store.patchState({ isOpen: false })
    "
  >
    <div
      class="ds-multi-select-overlay"
      data-test-id="atn-multi-select-overlay"
      [style.width.px]="overlayWidth"
    >
      @if (configOverlay.hasSearch) {
        <div
          class="ds-multi-select-overlay__search"
          data-test-id="atn-multi-select-overlay-search"
        >
          <i class="atn-icon atn-search atn-blue"></i>
          <input
            #searchInput
            (keyup)="store.patchState({ searchValue: searchInput.value })"
            [value]="searchValue"
            class="ds-multi-select-overlay__search-input"
            data-test-id="atn-multi-select-overlay-search-input"
            placeholder="Filter {{ configOverlay.entityName ?? 'Search' }}"
          />
          <!--  Reset search value-->
          @if (searchValue) {
            <i
              data-test-id="atn-multi-select-overlay-search-clear"
              class="atn-icon atn-close atn-blue"
              (click)="store.patchState({ searchValue: '' })"
            ></i>
          }
        </div>
      }
      @if (filteredCount) {
        <div class="ds-multi-select-overlay__items">
          <div class="ds-multi-select-overlay__item">
            <atn-ds-checkbox
              (selectedChange)="
                $event
                  ? store.patchState({ selectedValues: values })
                  : store.patchState({ selectedValues: [] })
              "
              label="Select all {{ configOverlay?.entityName }}"
              [selected]="selectedCount === totalCount"
              [someSelected]="selectedCount > 0 && selectedCount < totalCount"
            />
          </div>
          <div [style.height.px]="virtualScrollPxHeight">
            <cdk-virtual-scroll-viewport
              class="ds-multi-select-overlay__items-container"
              itemSize="27"
              maxBufferPx="54"
              minBufferPx="27"
            >
              <div
                *cdkVirtualFor="let filteredItem of filteredItems"
                class="ds-multi-select-overlay__item"
                data-test-id="atn-multi-select-overlay-item"
              >
                <atn-ds-checkbox
                  (selectedChange)="
                    $event
                      ? store.putSelectedValues(filteredItem.value)
                      : store.removeSelectedValues(filteredItem.value)
                  "
                  [label]="filteredItem.label"
                  [selected]="selectedValues.includes(filteredItem.value)"
                />
              </div>
            </cdk-virtual-scroll-viewport>
          </div>
        </div>
      } @else if (isLoading) {
        <span data-test-id="atn-multi-select-overlay-loading-state"
          >loading...</span
        >
      } @else {
        <div
          data-test-id="atn-multi-select-overlay-empty-state"
          class="ds-multi-select-overlay__empty-state"
        >
          <atn-ds-empty-state
            description="No items"
            layout="v"
            [title]="error ? error : 'No items'"
            [type]="error ? 'error' : 'no-data'"
          />
        </div>
      }
    </div>
  </atn-ds-attached-overlay>
}
